import { Validator } from '@vista-digital/validator';
import { cdnStandardAssetOptionsValidator } from '../../../validators/cdn-asset-options';
export const defaultShowtimePickerCdnOptions = {
    censorRatingIcon: { height: 60 },
    filmThumbnailImage: { width: 200 },
    attributeIcon: { height: 40 },
    heroAttributeIcon: { height: 64 },
    promotedAttributeIcon: { height: 32 }
};
export const showtimePickerCdnOptionsValidator = Validator.object({
    censorRatingIcon: cdnStandardAssetOptionsValidator,
    filmThumbnailImage: cdnStandardAssetOptionsValidator,
    attributeIcon: cdnStandardAssetOptionsValidator,
    heroAttributeIcon: cdnStandardAssetOptionsValidator,
    promotedAttributeIcon: cdnStandardAssetOptionsValidator
});
